import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx, withModifiers as _withModifiers, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "asset-history-container" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "card-header" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "asset-history-filters" }
const _hoisted_6 = { class: "d-flex flex-row flex-wrap gap-2 filter-controls" }
const _hoisted_7 = ["title"]
const _hoisted_8 = { class: "quick-range-buttons" }
const _hoisted_9 = { class: "quick-range-label" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "errors" }
const _hoisted_12 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_13 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_14 = {
  class: "spinner-border text-primary",
  role: "status"
}
const _hoisted_15 = { class: "visually-hidden" }
const _hoisted_16 = {
  key: 1,
  class: "alert alert-danger"
}
const _hoisted_17 = {
  key: 2,
  class: "history-chart-wrapper"
}
const _hoisted_18 = { class: "chart-header" }
const _hoisted_19 = { class: "chart-title" }
const _hoisted_20 = { class: "chart-actions" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "chart-body" }
const _hoisted_26 = { class: "chart-header" }
const _hoisted_27 = { class: "chart-title" }
const _hoisted_28 = { class: "chart-actions" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "chart-body" }
const _hoisted_34 = {
  key: 0,
  class: "history-placeholder"
}
const _hoisted_35 = { class: "chart-header" }
const _hoisted_36 = { class: "chart-title" }
const _hoisted_37 = { class: "chart-actions" }
const _hoisted_38 = ["onClick"]
const _hoisted_39 = ["onClick"]
const _hoisted_40 = ["onClick"]
const _hoisted_41 = ["onClick"]
const _hoisted_42 = { class: "chart-body" }
const _hoisted_43 = { class: "chart-header" }
const _hoisted_44 = { class: "chart-title" }
const _hoisted_45 = { class: "chart-actions" }
const _hoisted_46 = ["onClick"]
const _hoisted_47 = ["onClick"]
const _hoisted_48 = ["onClick"]
const _hoisted_49 = ["onClick"]
const _hoisted_50 = { class: "chart-body" }
const _hoisted_51 = { class: "chart-buttons-floating" }
const _hoisted_52 = {
  key: 0,
  class: "series-table-wrapper"
}
const _hoisted_53 = { class: "series-table-group-title" }
const _hoisted_54 = { class: "text-center" }
const _hoisted_55 = { class: "badge rounded-pill bg-primary fw-semibold" }
const _hoisted_56 = { class: "text-center" }
const _hoisted_57 = { class: "badge rounded-pill bg-info text-white fw-semibold" }
const _hoisted_58 = { class: "text-center" }
const _hoisted_59 = { class: "badge rounded-pill bg-danger fw-semibold" }
const _hoisted_60 = { class: "visibility-cell" }
const _hoisted_61 = { class: "form-check form-switch m-0" }
const _hoisted_62 = ["id", "checked", "onChange"]
const _hoisted_63 = ["for"]
const _hoisted_64 = {
  key: 0,
  class: "series-table-wrapper"
}
const _hoisted_65 = { class: "series-table-group-title" }
const _hoisted_66 = { class: "text-center" }
const _hoisted_67 = { class: "badge rounded-pill bg-primary fw-semibold" }
const _hoisted_68 = { class: "text-center" }
const _hoisted_69 = { class: "badge rounded-pill bg-info text-white fw-semibold" }
const _hoisted_70 = { class: "text-center" }
const _hoisted_71 = { class: "badge rounded-pill bg-danger fw-semibold" }
const _hoisted_72 = { class: "visibility-cell" }
const _hoisted_73 = { class: "form-check form-switch m-0" }
const _hoisted_74 = ["id", "checked", "onChange"]
const _hoisted_75 = ["for"]
const _hoisted_76 = {
  key: 0,
  class: "series-table-wrapper"
}
const _hoisted_77 = { class: "series-table-group-title" }
const _hoisted_78 = { class: "text-center" }
const _hoisted_79 = { class: "badge rounded-pill bg-primary fw-semibold" }
const _hoisted_80 = { class: "text-center" }
const _hoisted_81 = { class: "badge rounded-pill bg-info text-white fw-semibold" }
const _hoisted_82 = { class: "text-center" }
const _hoisted_83 = { class: "badge rounded-pill bg-danger fw-semibold" }
const _hoisted_84 = { class: "visibility-cell" }
const _hoisted_85 = { class: "form-check form-switch m-0" }
const _hoisted_86 = ["id", "checked", "onChange"]
const _hoisted_87 = ["for"]
const _hoisted_88 = {
  key: 0,
  class: "series-table-wrapper"
}
const _hoisted_89 = { class: "series-table-group-title" }
const _hoisted_90 = { class: "text-center" }
const _hoisted_91 = { class: "badge rounded-pill bg-primary fw-semibold" }
const _hoisted_92 = { class: "text-center" }
const _hoisted_93 = { class: "badge rounded-pill bg-info text-white fw-semibold" }
const _hoisted_94 = { class: "text-center" }
const _hoisted_95 = { class: "badge rounded-pill bg-danger fw-semibold" }
const _hoisted_96 = { class: "visibility-cell" }
const _hoisted_97 = { class: "form-check form-switch m-0" }
const _hoisted_98 = ["id", "checked", "onChange"]
const _hoisted_99 = ["for"]
const _hoisted_100 = {
  key: 10,
  class: "series-table-wrapper"
}
const _hoisted_101 = { class: "text-center" }
const _hoisted_102 = { class: "badge rounded-pill bg-primary fw-semibold" }
const _hoisted_103 = { class: "text-center" }
const _hoisted_104 = { class: "badge rounded-pill bg-info text-white fw-semibold" }
const _hoisted_105 = { class: "text-center" }
const _hoisted_106 = { class: "badge rounded-pill bg-danger fw-semibold" }
const _hoisted_107 = { class: "visibility-cell" }
const _hoisted_108 = { class: "form-check form-switch m-0" }
const _hoisted_109 = ["id", "checked", "onChange"]
const _hoisted_110 = ["for"]
const _hoisted_111 = {
  key: 3,
  class: "history-placeholder"
}
const _hoisted_112 = { class: "chart-buttons-floating" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_date_picker = _resolveComponent("date-picker")!
  const _component_WagoEnergyHeatmap = _resolveComponent("WagoEnergyHeatmap")!
  const _component_LineChart = _resolveComponent("LineChart")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h5", null, [
            _cache[14] || (_cache[14] = _createElementVNode("i", { class: "bi bi-clock-history" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('components.assetDetails.historyTitle')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_date_picker, {
                modelValue: _ctx.startDate,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.startDate) = $event)),
                class: "flex-grow",
                placeholder: _ctx.$t('components.datepicker.startPlaceholder'),
                type: 'datetime',
                range: false,
                "start-time": { hours: 0, minutes: 0 },
                "time-picker-inline": true,
                onEmitDate: _ctx.emitStartDate
              }, null, 8, ["modelValue", "placeholder", "onEmitDate"]),
              _createVNode(_component_date_picker, {
                modelValue: _ctx.endDate,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.endDate) = $event)),
                class: "flex-grow",
                placeholder: _ctx.$t('components.datepicker.endPlaceholder'),
                type: 'datetime',
                range: false,
                "start-time": { hours: 0, minutes: 0 },
                "time-picker-inline": true,
                onEmitDate: _ctx.emitEndDate
              }, null, 8, ["modelValue", "placeholder", "onEmitDate"]),
              (!_ctx.isSearching)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn btn-success btn-search",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.searchHistory && _ctx.searchHistory(...args)))
                  }, _toDisplayString(_ctx.$t('components.search')), 1))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "btn btn-success btn-search btn-search-disabled",
                    title: _ctx.$t('components.history.tooltip'),
                    "data-bs-toggle": "tooltip",
                    disabled: ""
                  }, _toDisplayString(_ctx.$t('components.search')), 9, _hoisted_7))
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('components.assetDetails.quickRangeLabel')), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rangePresets, (preset) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: preset.key,
                  type: "button",
                  class: _normalizeClass(["btn btn-light btn-sm", { active: _ctx.activePreset === preset.key }]),
                  onClick: ($event: any) => (_ctx.applyPreset(preset.key))
                }, _toDisplayString(_ctx.$t(preset.label)), 11, _hoisted_10))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_11, [
              (_ctx.filterError)
                ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_ctx.filterError), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('components.assetDetails.loading')), 1)
                ])
              ]))
            : (_ctx.error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _cache[15] || (_cache[15] = _createElementVNode("i", { class: "bi bi-exclamation-triangle" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.error), 1)
                ]))
              : (_ctx.chartHasData)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    (_ctx.isWagoAsset)
                      ? (_openBlock(), _createBlock(_component_WagoEnergyHeatmap, {
                          key: 0,
                          "chart-series": _ctx.heatmapSeries,
                          "is-dark-mode": _ctx.isDarkMode,
                          "range-start-ts": _ctx.heatmapRangeStartTs,
                          "range-end-ts": _ctx.heatmapRangeEndTs
                        }, null, 8, ["chart-series", "is-dark-mode", "range-start-ts", "range-end-ts"]))
                      : _createCommentVNode("", true),
                    (_ctx.isWagoAsset)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.wagoChartGroups, (group) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: group.id
                          }, [
                            (_ctx.wagoGroupHasData(group) && _ctx.wagoGroupHasVisibleSeries(group))
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: _normalizeClass(["chart-container chart-container--wago mb-3", { 'dark-mode': _ctx.isDarkMode }])
                                }, [
                                  _createElementVNode("div", _hoisted_18, [
                                    _createElementVNode("h3", _hoisted_19, [
                                      _cache[16] || (_cache[16] = _createElementVNode("i", { class: "bi bi-graph-up" }, null, -1)),
                                      _createElementVNode("span", null, _toDisplayString(_ctx.$t(group.titleKey)), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_20, [
                                      _createElementVNode("button", {
                                        class: "btn btn-custom",
                                        type: "button",
                                        onClick: ($event: any) => (_ctx.resetWagoGroupZoom(group.id)),
                                        title: "Reset zoom"
                                      }, [...(_cache[17] || (_cache[17] = [
                                        _createElementVNode("i", { class: "bi bi-arrow-clockwise" }, null, -1)
                                      ]))], 8, _hoisted_21),
                                      _createElementVNode("button", {
                                        class: "btn btn-custom chart-action-export",
                                        type: "button",
                                        onClick: ($event: any) => (_ctx.exportWagoGroupToPng(group)),
                                        title: "Eksport PNG"
                                      }, [...(_cache[18] || (_cache[18] = [
                                        _createElementVNode("i", { class: "bi bi-filetype-png" }, null, -1)
                                      ]))], 8, _hoisted_22),
                                      _createElementVNode("button", {
                                        class: "btn btn-custom chart-action-export",
                                        type: "button",
                                        onClick: ($event: any) => (_ctx.exportWagoGroupToJpg(group)),
                                        title: "Eksport JPG"
                                      }, [...(_cache[19] || (_cache[19] = [
                                        _createElementVNode("i", { class: "bi bi-filetype-jpg" }, null, -1)
                                      ]))], 8, _hoisted_23),
                                      _createElementVNode("button", {
                                        class: "btn btn-custom chart-action-export",
                                        type: "button",
                                        onClick: ($event: any) => (_ctx.exportWagoGroupCsv(group)),
                                        title: "Eksport CSV"
                                      }, [...(_cache[20] || (_cache[20] = [
                                        _createElementVNode("i", { class: "bi bi-filetype-csv" }, null, -1)
                                      ]))], 8, _hoisted_24)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_25, [
                                    (_openBlock(), _createBlock(_component_LineChart, {
                                      key: group.id + '-' + (_ctx.isDarkMode ? 'dark' : 'light'),
                                      height: _ctx.wagoChartHeight,
                                      "chart-id": 'wago-history-chart-' + group.id,
                                      "chart-data": _ctx.wagoChartDataForHistory(group),
                                      options: _ctx.wagoChartOptions(group),
                                      plugins: _ctx.chartPlugins
                                    }, null, 8, ["height", "chart-id", "chart-data", "options", "plugins"]))
                                  ])
                                ], 2))
                              : _createCommentVNode("", true)
                          ], 64))
                        }), 128))
                      : (_ctx.isDknLmsAsset)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.dknChartGroups, (group) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: group.id
                            }, [
                              (_ctx.dknGroupHasData(group) && _ctx.dknGroupHasVisibleSeries(group))
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: _normalizeClass(["chart-container chart-container--wago mb-3", { 'dark-mode': _ctx.isDarkMode }])
                                  }, [
                                    _createElementVNode("div", _hoisted_26, [
                                      _createElementVNode("h3", _hoisted_27, [
                                        _cache[21] || (_cache[21] = _createElementVNode("i", { class: "bi bi-graph-up" }, null, -1)),
                                        _createElementVNode("span", null, _toDisplayString(_ctx.$t(group.titleKey)), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_28, [
                                        _createElementVNode("button", {
                                          class: "btn btn-custom",
                                          type: "button",
                                          onClick: ($event: any) => (_ctx.resetDknGroupZoom(group.id)),
                                          title: "Reset zoom"
                                        }, [...(_cache[22] || (_cache[22] = [
                                          _createElementVNode("i", { class: "bi bi-arrow-clockwise" }, null, -1)
                                        ]))], 8, _hoisted_29),
                                        _createElementVNode("button", {
                                          class: "btn btn-custom chart-action-export",
                                          type: "button",
                                          onClick: ($event: any) => (_ctx.exportDknGroupToPng(group)),
                                          title: "Eksport PNG"
                                        }, [...(_cache[23] || (_cache[23] = [
                                          _createElementVNode("i", { class: "bi bi-filetype-png" }, null, -1)
                                        ]))], 8, _hoisted_30),
                                        _createElementVNode("button", {
                                          class: "btn btn-custom chart-action-export",
                                          type: "button",
                                          onClick: ($event: any) => (_ctx.exportDknGroupToJpg(group)),
                                          title: "Eksport JPG"
                                        }, [...(_cache[24] || (_cache[24] = [
                                          _createElementVNode("i", { class: "bi bi-filetype-jpg" }, null, -1)
                                        ]))], 8, _hoisted_31),
                                        _createElementVNode("button", {
                                          class: "btn btn-custom chart-action-export",
                                          type: "button",
                                          onClick: ($event: any) => (_ctx.exportDknGroupCsv(group)),
                                          title: "Eksport CSV"
                                        }, [...(_cache[25] || (_cache[25] = [
                                          _createElementVNode("i", { class: "bi bi-filetype-csv" }, null, -1)
                                        ]))], 8, _hoisted_32)
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_33, [
                                      (_openBlock(), _createBlock(_component_LineChart, {
                                        key: 'dkn-' + group.id + '-' + (_ctx.isDarkMode ? 'dark' : 'light'),
                                        height: _ctx.wagoChartHeight,
                                        "chart-id": 'dkn-history-chart-' + group.id,
                                        "chart-data": _ctx.dknChartDataForHistory(group),
                                        options: _ctx.dknChartOptions(group),
                                        plugins: _ctx.chartPlugins
                                      }, null, 8, ["height", "chart-id", "chart-data", "options", "plugins"]))
                                    ])
                                  ], 2))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        : (_ctx.isDknUartDetected)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                              (!_ctx.isDknUartAsset)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                    _cache[26] || (_cache[26] = _createElementVNode("i", { class: "bi bi-inbox" }, null, -1)),
                                    _createElementVNode("p", null, _toDisplayString(_ctx.$t('components.assetDetails.noDataInRange')), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uartChartGroups, (group) => {
                                return (_openBlock(), _createElementBlock(_Fragment, {
                                  key: group.id
                                }, [
                                  (_ctx.dknGroupHasData(group) && _ctx.dknGroupHasVisibleSeries(group))
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: _normalizeClass(["chart-container chart-container--wago mb-3", { 'dark-mode': _ctx.isDarkMode }])
                                      }, [
                                        _createElementVNode("div", _hoisted_35, [
                                          _createElementVNode("h3", _hoisted_36, [
                                            _cache[27] || (_cache[27] = _createElementVNode("i", { class: "bi bi-graph-up" }, null, -1)),
                                            _createElementVNode("span", null, _toDisplayString(_ctx.$t(group.titleKey)), 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_37, [
                                            _createElementVNode("button", {
                                              class: "btn btn-custom",
                                              type: "button",
                                              onClick: ($event: any) => (_ctx.resetUartGroupZoom(group.id)),
                                              title: "Reset zoom"
                                            }, [...(_cache[28] || (_cache[28] = [
                                              _createElementVNode("i", { class: "bi bi-arrow-clockwise" }, null, -1)
                                            ]))], 8, _hoisted_38),
                                            _createElementVNode("button", {
                                              class: "btn btn-custom chart-action-export",
                                              type: "button",
                                              onClick: ($event: any) => (_ctx.exportUartGroupToPng(group)),
                                              title: "Eksport PNG"
                                            }, [...(_cache[29] || (_cache[29] = [
                                              _createElementVNode("i", { class: "bi bi-filetype-png" }, null, -1)
                                            ]))], 8, _hoisted_39),
                                            _createElementVNode("button", {
                                              class: "btn btn-custom chart-action-export",
                                              type: "button",
                                              onClick: ($event: any) => (_ctx.exportUartGroupToJpg(group)),
                                              title: "Eksport JPG"
                                            }, [...(_cache[30] || (_cache[30] = [
                                              _createElementVNode("i", { class: "bi bi-filetype-jpg" }, null, -1)
                                            ]))], 8, _hoisted_40),
                                            _createElementVNode("button", {
                                              class: "btn btn-custom chart-action-export",
                                              type: "button",
                                              onClick: ($event: any) => (_ctx.exportUartGroupCsv(group)),
                                              title: "Eksport CSV"
                                            }, [...(_cache[31] || (_cache[31] = [
                                              _createElementVNode("i", { class: "bi bi-filetype-csv" }, null, -1)
                                            ]))], 8, _hoisted_41)
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_42, [
                                          (_openBlock(), _createBlock(_component_LineChart, {
                                            key: 'uart-' + group.id + '-' + (_ctx.isDarkMode ? 'dark' : 'light'),
                                            height: _ctx.wagoChartHeight,
                                            "chart-id": 'uart-history-chart-' + group.id,
                                            "chart-data": _ctx.dknChartDataForHistory(group),
                                            options: _ctx.dknChartOptions(group),
                                            plugins: _ctx.chartPlugins
                                          }, null, 8, ["height", "chart-id", "chart-data", "options", "plugins"]))
                                        ])
                                      ], 2))
                                    : _createCommentVNode("", true)
                                ], 64))
                              }), 128))
                            ], 64))
                          : (_ctx.isDknMpsAsset)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 4 }, _renderList(_ctx.mpsChartGroups, (group) => {
                                return (_openBlock(), _createElementBlock(_Fragment, {
                                  key: group.id
                                }, [
                                  (_ctx.dknGroupHasData(group) && _ctx.dknGroupHasVisibleSeries(group))
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: _normalizeClass(["chart-container chart-container--wago mb-3", { 'dark-mode': _ctx.isDarkMode }])
                                      }, [
                                        _createElementVNode("div", _hoisted_43, [
                                          _createElementVNode("h3", _hoisted_44, [
                                            _cache[32] || (_cache[32] = _createElementVNode("i", { class: "bi bi-graph-up" }, null, -1)),
                                            _createElementVNode("span", null, _toDisplayString(_ctx.$t(group.titleKey)), 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_45, [
                                            _createElementVNode("button", {
                                              class: "btn btn-custom",
                                              type: "button",
                                              onClick: ($event: any) => (_ctx.resetMpsGroupZoom(group.id)),
                                              title: "Reset zoom"
                                            }, [...(_cache[33] || (_cache[33] = [
                                              _createElementVNode("i", { class: "bi bi-arrow-clockwise" }, null, -1)
                                            ]))], 8, _hoisted_46),
                                            _createElementVNode("button", {
                                              class: "btn btn-custom chart-action-export",
                                              type: "button",
                                              onClick: ($event: any) => (_ctx.exportMpsGroupToPng(group)),
                                              title: "Eksport PNG"
                                            }, [...(_cache[34] || (_cache[34] = [
                                              _createElementVNode("i", { class: "bi bi-filetype-png" }, null, -1)
                                            ]))], 8, _hoisted_47),
                                            _createElementVNode("button", {
                                              class: "btn btn-custom chart-action-export",
                                              type: "button",
                                              onClick: ($event: any) => (_ctx.exportMpsGroupToJpg(group)),
                                              title: "Eksport JPG"
                                            }, [...(_cache[35] || (_cache[35] = [
                                              _createElementVNode("i", { class: "bi bi-filetype-jpg" }, null, -1)
                                            ]))], 8, _hoisted_48),
                                            _createElementVNode("button", {
                                              class: "btn btn-custom chart-action-export",
                                              type: "button",
                                              onClick: ($event: any) => (_ctx.exportMpsGroupCsv(group)),
                                              title: "Eksport CSV"
                                            }, [...(_cache[36] || (_cache[36] = [
                                              _createElementVNode("i", { class: "bi bi-filetype-csv" }, null, -1)
                                            ]))], 8, _hoisted_49)
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_50, [
                                          (_openBlock(), _createBlock(_component_LineChart, {
                                            key: 'mps-' + group.id + '-' + (_ctx.isDarkMode ? 'dark' : 'light'),
                                            height: _ctx.wagoChartHeight,
                                            "chart-id": 'mps-history-chart-' + group.id,
                                            "chart-data": _ctx.dknChartDataForHistory(group),
                                            options: _ctx.dknChartOptions(group),
                                            plugins: _ctx.chartPlugins
                                          }, null, 8, ["height", "chart-id", "chart-data", "options", "plugins"]))
                                        ])
                                      ], 2))
                                    : _createCommentVNode("", true)
                                ], 64))
                              }), 128))
                            : (!_ctx.isChartFullscreen)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 5,
                                  class: _normalizeClass(["chart-container", { 'dark-mode': _ctx.isDarkMode }])
                                }, [
                                  _createElementVNode("div", _hoisted_51, [
                                    _createElementVNode("button", {
                                      class: "btn btn-custom",
                                      type: "button",
                                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openChartFullscreen && _ctx.openChartFullscreen(...args))),
                                      title: "Pełny ekran"
                                    }, [...(_cache[37] || (_cache[37] = [
                                      _createElementVNode("i", { class: "bi bi-arrows-fullscreen" }, null, -1)
                                    ]))]),
                                    _createElementVNode("button", {
                                      class: "btn btn-custom",
                                      type: "button",
                                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.resetChartZoom && _ctx.resetChartZoom(...args))),
                                      title: "Reset zoom"
                                    }, [...(_cache[38] || (_cache[38] = [
                                      _createElementVNode("i", { class: "bi bi-arrow-clockwise" }, null, -1)
                                    ]))]),
                                    _createElementVNode("button", {
                                      class: "btn btn-custom chart-action-export",
                                      type: "button",
                                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.exportToPng && _ctx.exportToPng(...args))),
                                      title: "Eksport PNG"
                                    }, [...(_cache[39] || (_cache[39] = [
                                      _createElementVNode("i", { class: "bi bi-filetype-png" }, null, -1)
                                    ]))]),
                                    _createElementVNode("button", {
                                      class: "btn btn-custom chart-action-export",
                                      type: "button",
                                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.exportToJpg && _ctx.exportToJpg(...args))),
                                      title: "Eksport JPG"
                                    }, [...(_cache[40] || (_cache[40] = [
                                      _createElementVNode("i", { class: "bi bi-filetype-jpg" }, null, -1)
                                    ]))]),
                                    _createElementVNode("button", {
                                      class: "btn btn-custom chart-action-export",
                                      type: "button",
                                      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.exportCsv && _ctx.exportCsv(...args))),
                                      title: "Eksport CSV"
                                    }, [...(_cache[41] || (_cache[41] = [
                                      _createElementVNode("i", { class: "bi bi-filetype-csv" }, null, -1)
                                    ]))])
                                  ]),
                                  (_openBlock(), _createBlock(_component_LineChart, {
                                    ref: "historyChart",
                                    key: _ctx.chartRenderKey,
                                    height: 550,
                                    "chart-id": _ctx.chartId,
                                    "chart-data": _ctx.chartData,
                                    options: _ctx.chartOptions,
                                    plugins: _ctx.chartPlugins
                                  }, null, 8, ["chart-id", "chart-data", "options", "plugins"]))
                                ], 2))
                              : _createCommentVNode("", true),
                    (_ctx.isWagoAsset)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 6 }, _renderList(_ctx.wagoChartGroups, (group) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: 'table-' + group.id
                          }, [
                            (_ctx.wagoGroupHasData(group))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                  _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.$t(group.titleKey)), 1),
                                  _createVNode(_component_DxDataGrid, {
                                    class: "series-grid",
                                    "data-source": _ctx.wagoGroupSeriesStats(group),
                                    "show-borders": false,
                                    "row-alternation-enabled": true,
                                    "column-auto-width": true,
                                    "column-hiding-enabled": true,
                                    "hover-state-enabled": false
                                  }, {
                                    "min-chip": _withCtx(({ data }) => [
                                      _createElementVNode("div", _hoisted_54, [
                                        _createElementVNode("span", _hoisted_55, _toDisplayString(data.data.min), 1)
                                      ])
                                    ]),
                                    "avg-chip": _withCtx(({ data }) => [
                                      _createElementVNode("div", _hoisted_56, [
                                        _createElementVNode("span", _hoisted_57, _toDisplayString(data.data.avg), 1)
                                      ])
                                    ]),
                                    "max-chip": _withCtx(({ data }) => [
                                      _createElementVNode("div", _hoisted_58, [
                                        _createElementVNode("span", _hoisted_59, _toDisplayString(data.data.max), 1)
                                      ])
                                    ]),
                                    "visibility-cell": _withCtx(({ data }) => [
                                      _createElementVNode("div", _hoisted_60, [
                                        _createElementVNode("div", _hoisted_61, [
                                          _createElementVNode("input", {
                                            class: "form-check-input",
                                            type: "checkbox",
                                            id: `series-switch-${data.data.key}`,
                                            checked: data.data.visible,
                                            onChange: (e) => _ctx.onSeriesVisibilityToggle(data.data.key, (e.target as HTMLInputElement).checked)
                                          }, null, 40, _hoisted_62),
                                          _createElementVNode("label", {
                                            class: "form-check-label",
                                            for: `series-switch-${data.data.key}`
                                          }, null, 8, _hoisted_63)
                                        ]),
                                        _createElementVNode("span", {
                                          class: _normalizeClass(data.data.visible ? 'status-visible' : 'status-hidden')
                                        }, _toDisplayString(data.data.visible ? _ctx.$t('components.assetDetails.seriesTable.visibleLabel') : _ctx.$t('components.assetDetails.seriesTable.hiddenLabel')), 3)
                                      ])
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_DxColumn, {
                                        "data-field": "visible",
                                        caption: _ctx.$t('components.assetDetails.seriesTable.visible'),
                                        "cell-template": "visibility-cell",
                                        "allow-sorting": false,
                                        "allow-filtering": false,
                                        alignment: "center"
                                      }, null, 8, ["caption"]),
                                      _createVNode(_component_DxColumn, {
                                        "data-field": "label",
                                        caption: _ctx.$t('components.assetDetails.seriesTable.series'),
                                        alignment: "center"
                                      }, null, 8, ["caption"]),
                                      _createVNode(_component_DxColumn, {
                                        "data-field": "min",
                                        caption: _ctx.$t('components.assetDetails.seriesTable.min'),
                                        "cell-template": "min-chip",
                                        alignment: "center"
                                      }, null, 8, ["caption"]),
                                      _createVNode(_component_DxColumn, {
                                        "data-field": "avg",
                                        caption: _ctx.$t('components.assetDetails.seriesTable.avg'),
                                        "cell-template": "avg-chip",
                                        alignment: "center"
                                      }, null, 8, ["caption"]),
                                      _createVNode(_component_DxColumn, {
                                        "data-field": "max",
                                        caption: _ctx.$t('components.assetDetails.seriesTable.max'),
                                        "cell-template": "max-chip",
                                        alignment: "center"
                                      }, null, 8, ["caption"])
                                    ]),
                                    _: 1
                                  }, 8, ["data-source"])
                                ]))
                              : _createCommentVNode("", true)
                          ], 64))
                        }), 128))
                      : (_ctx.isDknLmsAsset)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 7 }, _renderList(_ctx.dknChartGroups, (group) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: 'dkn-table-' + group.id
                            }, [
                              (_ctx.dknGroupHasData(group))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                    _createElementVNode("div", _hoisted_65, _toDisplayString(_ctx.$t(group.titleKey)), 1),
                                    _createVNode(_component_DxDataGrid, {
                                      class: "series-grid",
                                      "data-source": _ctx.dknGroupSeriesStats(group),
                                      "show-borders": false,
                                      "row-alternation-enabled": true,
                                      "column-auto-width": true,
                                      "column-hiding-enabled": true,
                                      "hover-state-enabled": false
                                    }, {
                                      "min-chip": _withCtx(({ data }) => [
                                        _createElementVNode("div", _hoisted_66, [
                                          _createElementVNode("span", _hoisted_67, _toDisplayString(data.data.min), 1)
                                        ])
                                      ]),
                                      "avg-chip": _withCtx(({ data }) => [
                                        _createElementVNode("div", _hoisted_68, [
                                          _createElementVNode("span", _hoisted_69, _toDisplayString(data.data.avg), 1)
                                        ])
                                      ]),
                                      "max-chip": _withCtx(({ data }) => [
                                        _createElementVNode("div", _hoisted_70, [
                                          _createElementVNode("span", _hoisted_71, _toDisplayString(data.data.max), 1)
                                        ])
                                      ]),
                                      "visibility-cell": _withCtx(({ data }) => [
                                        _createElementVNode("div", _hoisted_72, [
                                          _createElementVNode("div", _hoisted_73, [
                                            _createElementVNode("input", {
                                              class: "form-check-input",
                                              type: "checkbox",
                                              id: `dkn-series-switch-${data.data.key}`,
                                              checked: data.data.visible,
                                              onChange: (e) => _ctx.onSeriesVisibilityToggle(data.data.key, (e.target as HTMLInputElement).checked)
                                            }, null, 40, _hoisted_74),
                                            _createElementVNode("label", {
                                              class: "form-check-label",
                                              for: `dkn-series-switch-${data.data.key}`
                                            }, null, 8, _hoisted_75)
                                          ]),
                                          _createElementVNode("span", {
                                            class: _normalizeClass(data.data.visible ? 'status-visible' : 'status-hidden')
                                          }, _toDisplayString(data.data.visible ? _ctx.$t('components.assetDetails.seriesTable.visibleLabel') : _ctx.$t('components.assetDetails.seriesTable.hiddenLabel')), 3)
                                        ])
                                      ]),
                                      default: _withCtx(() => [
                                        _createVNode(_component_DxColumn, {
                                          "data-field": "visible",
                                          caption: _ctx.$t('components.assetDetails.seriesTable.visible'),
                                          "cell-template": "visibility-cell",
                                          "allow-sorting": false,
                                          "allow-filtering": false,
                                          alignment: "center"
                                        }, null, 8, ["caption"]),
                                        _createVNode(_component_DxColumn, {
                                          "data-field": "label",
                                          caption: _ctx.$t('components.assetDetails.seriesTable.series'),
                                          alignment: "center"
                                        }, null, 8, ["caption"]),
                                        _createVNode(_component_DxColumn, {
                                          "data-field": "min",
                                          caption: _ctx.$t('components.assetDetails.seriesTable.min'),
                                          "cell-template": "min-chip",
                                          alignment: "center"
                                        }, null, 8, ["caption"]),
                                        _createVNode(_component_DxColumn, {
                                          "data-field": "avg",
                                          caption: _ctx.$t('components.assetDetails.seriesTable.avg'),
                                          "cell-template": "avg-chip",
                                          alignment: "center"
                                        }, null, 8, ["caption"]),
                                        _createVNode(_component_DxColumn, {
                                          "data-field": "max",
                                          caption: _ctx.$t('components.assetDetails.seriesTable.max'),
                                          "cell-template": "max-chip",
                                          alignment: "center"
                                        }, null, 8, ["caption"])
                                      ]),
                                      _: 1
                                    }, 8, ["data-source"])
                                  ]))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        : (_ctx.isDknUartDetected)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 8 }, _renderList(_ctx.uartChartGroups, (group) => {
                              return (_openBlock(), _createElementBlock(_Fragment, {
                                key: 'uart-table-' + group.id
                              }, [
                                (_ctx.dknGroupHasData(group))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                                      _createElementVNode("div", _hoisted_77, _toDisplayString(_ctx.$t(group.titleKey)), 1),
                                      _createVNode(_component_DxDataGrid, {
                                        class: "series-grid",
                                        "data-source": _ctx.dknGroupSeriesStats(group),
                                        "show-borders": false,
                                        "row-alternation-enabled": true,
                                        "column-auto-width": true,
                                        "column-hiding-enabled": true,
                                        "hover-state-enabled": false
                                      }, {
                                        "min-chip": _withCtx(({ data }) => [
                                          _createElementVNode("div", _hoisted_78, [
                                            _createElementVNode("span", _hoisted_79, _toDisplayString(data.data.min), 1)
                                          ])
                                        ]),
                                        "avg-chip": _withCtx(({ data }) => [
                                          _createElementVNode("div", _hoisted_80, [
                                            _createElementVNode("span", _hoisted_81, _toDisplayString(data.data.avg), 1)
                                          ])
                                        ]),
                                        "max-chip": _withCtx(({ data }) => [
                                          _createElementVNode("div", _hoisted_82, [
                                            _createElementVNode("span", _hoisted_83, _toDisplayString(data.data.max), 1)
                                          ])
                                        ]),
                                        "visibility-cell": _withCtx(({ data }) => [
                                          _createElementVNode("div", _hoisted_84, [
                                            _createElementVNode("div", _hoisted_85, [
                                              _createElementVNode("input", {
                                                class: "form-check-input",
                                                type: "checkbox",
                                                id: `uart-series-switch-${data.data.key}`,
                                                checked: data.data.visible,
                                                onChange: (e) => _ctx.onSeriesVisibilityToggle(data.data.key, (e.target as HTMLInputElement).checked)
                                              }, null, 40, _hoisted_86),
                                              _createElementVNode("label", {
                                                class: "form-check-label",
                                                for: `uart-series-switch-${data.data.key}`
                                              }, null, 8, _hoisted_87)
                                            ]),
                                            _createElementVNode("span", {
                                              class: _normalizeClass(data.data.visible ? 'status-visible' : 'status-hidden')
                                            }, _toDisplayString(data.data.visible ? _ctx.$t('components.assetDetails.seriesTable.visibleLabel') : _ctx.$t('components.assetDetails.seriesTable.hiddenLabel')), 3)
                                          ])
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(_component_DxColumn, {
                                            "data-field": "visible",
                                            caption: _ctx.$t('components.assetDetails.seriesTable.visible'),
                                            "cell-template": "visibility-cell",
                                            "allow-sorting": false,
                                            "allow-filtering": false,
                                            alignment: "center"
                                          }, null, 8, ["caption"]),
                                          _createVNode(_component_DxColumn, {
                                            "data-field": "label",
                                            caption: _ctx.$t('components.assetDetails.seriesTable.series'),
                                            alignment: "center"
                                          }, null, 8, ["caption"]),
                                          _createVNode(_component_DxColumn, {
                                            "data-field": "min",
                                            caption: _ctx.$t('components.assetDetails.seriesTable.min'),
                                            "cell-template": "min-chip",
                                            alignment: "center"
                                          }, null, 8, ["caption"]),
                                          _createVNode(_component_DxColumn, {
                                            "data-field": "avg",
                                            caption: _ctx.$t('components.assetDetails.seriesTable.avg'),
                                            "cell-template": "avg-chip",
                                            alignment: "center"
                                          }, null, 8, ["caption"]),
                                          _createVNode(_component_DxColumn, {
                                            "data-field": "max",
                                            caption: _ctx.$t('components.assetDetails.seriesTable.max'),
                                            "cell-template": "max-chip",
                                            alignment: "center"
                                          }, null, 8, ["caption"])
                                        ]),
                                        _: 1
                                      }, 8, ["data-source"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            }), 128))
                          : (_ctx.isDknMpsAsset)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 9 }, _renderList(_ctx.mpsChartGroups, (group) => {
                                return (_openBlock(), _createElementBlock(_Fragment, {
                                  key: 'mps-table-' + group.id
                                }, [
                                  (_ctx.dknGroupHasData(group))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                                        _createElementVNode("div", _hoisted_89, _toDisplayString(_ctx.$t(group.titleKey)), 1),
                                        _createVNode(_component_DxDataGrid, {
                                          class: "series-grid",
                                          "data-source": _ctx.dknGroupSeriesStats(group),
                                          "show-borders": false,
                                          "row-alternation-enabled": true,
                                          "column-auto-width": true,
                                          "column-hiding-enabled": true,
                                          "hover-state-enabled": false
                                        }, {
                                          "min-chip": _withCtx(({ data }) => [
                                            _createElementVNode("div", _hoisted_90, [
                                              _createElementVNode("span", _hoisted_91, _toDisplayString(data.data.min), 1)
                                            ])
                                          ]),
                                          "avg-chip": _withCtx(({ data }) => [
                                            _createElementVNode("div", _hoisted_92, [
                                              _createElementVNode("span", _hoisted_93, _toDisplayString(data.data.avg), 1)
                                            ])
                                          ]),
                                          "max-chip": _withCtx(({ data }) => [
                                            _createElementVNode("div", _hoisted_94, [
                                              _createElementVNode("span", _hoisted_95, _toDisplayString(data.data.max), 1)
                                            ])
                                          ]),
                                          "visibility-cell": _withCtx(({ data }) => [
                                            _createElementVNode("div", _hoisted_96, [
                                              _createElementVNode("div", _hoisted_97, [
                                                _createElementVNode("input", {
                                                  class: "form-check-input",
                                                  type: "checkbox",
                                                  id: `mps-series-switch-${data.data.key}`,
                                                  checked: data.data.visible,
                                                  onChange: (e) => _ctx.onSeriesVisibilityToggle(data.data.key, (e.target as HTMLInputElement).checked)
                                                }, null, 40, _hoisted_98),
                                                _createElementVNode("label", {
                                                  class: "form-check-label",
                                                  for: `mps-series-switch-${data.data.key}`
                                                }, null, 8, _hoisted_99)
                                              ]),
                                              _createElementVNode("span", {
                                                class: _normalizeClass(data.data.visible ? 'status-visible' : 'status-hidden')
                                              }, _toDisplayString(data.data.visible ? _ctx.$t('components.assetDetails.seriesTable.visibleLabel') : _ctx.$t('components.assetDetails.seriesTable.hiddenLabel')), 3)
                                            ])
                                          ]),
                                          default: _withCtx(() => [
                                            _createVNode(_component_DxColumn, {
                                              "data-field": "visible",
                                              caption: _ctx.$t('components.assetDetails.seriesTable.visible'),
                                              "cell-template": "visibility-cell",
                                              "allow-sorting": false,
                                              "allow-filtering": false,
                                              alignment: "center"
                                            }, null, 8, ["caption"]),
                                            _createVNode(_component_DxColumn, {
                                              "data-field": "label",
                                              caption: _ctx.$t('components.assetDetails.seriesTable.series'),
                                              alignment: "center"
                                            }, null, 8, ["caption"]),
                                            _createVNode(_component_DxColumn, {
                                              "data-field": "min",
                                              caption: _ctx.$t('components.assetDetails.seriesTable.min'),
                                              "cell-template": "min-chip",
                                              alignment: "center"
                                            }, null, 8, ["caption"]),
                                            _createVNode(_component_DxColumn, {
                                              "data-field": "avg",
                                              caption: _ctx.$t('components.assetDetails.seriesTable.avg'),
                                              "cell-template": "avg-chip",
                                              alignment: "center"
                                            }, null, 8, ["caption"]),
                                            _createVNode(_component_DxColumn, {
                                              "data-field": "max",
                                              caption: _ctx.$t('components.assetDetails.seriesTable.max'),
                                              "cell-template": "max-chip",
                                              alignment: "center"
                                            }, null, 8, ["caption"])
                                          ]),
                                          _: 1
                                        }, 8, ["data-source"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ], 64))
                              }), 128))
                            : (_openBlock(), _createElementBlock("div", _hoisted_100, [
                                _createVNode(_component_DxDataGrid, {
                                  class: "series-grid",
                                  "data-source": _ctx.seriesStats,
                                  "show-borders": false,
                                  "row-alternation-enabled": true,
                                  "column-auto-width": true,
                                  "column-hiding-enabled": true,
                                  "hover-state-enabled": false
                                }, {
                                  "min-chip": _withCtx(({ data }) => [
                                    _createElementVNode("div", _hoisted_101, [
                                      _createElementVNode("span", _hoisted_102, _toDisplayString(data.data.min), 1)
                                    ])
                                  ]),
                                  "avg-chip": _withCtx(({ data }) => [
                                    _createElementVNode("div", _hoisted_103, [
                                      _createElementVNode("span", _hoisted_104, _toDisplayString(data.data.avg), 1)
                                    ])
                                  ]),
                                  "max-chip": _withCtx(({ data }) => [
                                    _createElementVNode("div", _hoisted_105, [
                                      _createElementVNode("span", _hoisted_106, _toDisplayString(data.data.max), 1)
                                    ])
                                  ]),
                                  "visibility-cell": _withCtx(({ data }) => [
                                    _createElementVNode("div", _hoisted_107, [
                                      _createElementVNode("div", _hoisted_108, [
                                        _createElementVNode("input", {
                                          class: "form-check-input",
                                          type: "checkbox",
                                          id: `series-switch-${data.data.key}`,
                                          checked: data.data.visible,
                                          onChange: (e) => _ctx.onSeriesVisibilityToggle(data.data.key, (e.target as HTMLInputElement).checked)
                                        }, null, 40, _hoisted_109),
                                        _createElementVNode("label", {
                                          class: "form-check-label",
                                          for: `series-switch-${data.data.key}`
                                        }, null, 8, _hoisted_110)
                                      ]),
                                      _createElementVNode("span", {
                                        class: _normalizeClass(data.data.visible ? 'status-visible' : 'status-hidden')
                                      }, _toDisplayString(data.data.visible ? _ctx.$t('components.assetDetails.seriesTable.visibleLabel') : _ctx.$t('components.assetDetails.seriesTable.hiddenLabel')), 3)
                                    ])
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_DxColumn, {
                                      "data-field": "visible",
                                      caption: _ctx.$t('components.assetDetails.seriesTable.visible'),
                                      "cell-template": "visibility-cell",
                                      "allow-sorting": false,
                                      "allow-filtering": false,
                                      alignment: "center"
                                    }, null, 8, ["caption"]),
                                    _createVNode(_component_DxColumn, {
                                      "data-field": "label",
                                      caption: _ctx.$t('components.assetDetails.seriesTable.series'),
                                      alignment: "center"
                                    }, null, 8, ["caption"]),
                                    _createVNode(_component_DxColumn, {
                                      "data-field": "min",
                                      caption: _ctx.$t('components.assetDetails.seriesTable.min'),
                                      "cell-template": "min-chip",
                                      alignment: "center"
                                    }, null, 8, ["caption"]),
                                    _createVNode(_component_DxColumn, {
                                      "data-field": "avg",
                                      caption: _ctx.$t('components.assetDetails.seriesTable.avg'),
                                      "cell-template": "avg-chip",
                                      alignment: "center"
                                    }, null, 8, ["caption"]),
                                    _createVNode(_component_DxColumn, {
                                      "data-field": "max",
                                      caption: _ctx.$t('components.assetDetails.seriesTable.max'),
                                      "cell-template": "max-chip",
                                      alignment: "center"
                                    }, null, 8, ["caption"])
                                  ]),
                                  _: 1
                                }, 8, ["data-source"])
                              ]))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_111, [
                    _cache[42] || (_cache[42] = _createElementVNode("i", { class: "bi bi-inbox" }, null, -1)),
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t('components.assetDetails.noHistory')), 1)
                  ]))
        ])
      ])
    ]),
    (!_ctx.isWagoAsset)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 0,
          to: "body"
        }, [
          (_ctx.isChartFullscreen)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["asset-history-container chart-fullscreen-overlay", { 'dark-mode': _ctx.isDarkMode }]),
                onClick: _cache[13] || (_cache[13] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeChartFullscreen && _ctx.closeChartFullscreen(...args)), ["self"]))
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["chart-container chart-container-fullscreen", { 'dark-mode': _ctx.isDarkMode }])
                }, [
                  _createElementVNode("div", _hoisted_112, [
                    _createElementVNode("button", {
                      class: "btn btn-custom",
                      type: "button",
                      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.closeChartFullscreen && _ctx.closeChartFullscreen(...args))),
                      title: "Zamknij"
                    }, [...(_cache[43] || (_cache[43] = [
                      _createElementVNode("i", { class: "bi bi-x-lg" }, null, -1)
                    ]))]),
                    _createElementVNode("button", {
                      class: "btn btn-custom",
                      type: "button",
                      onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.resetChartZoom && _ctx.resetChartZoom(...args))),
                      title: "Reset zoom"
                    }, [...(_cache[44] || (_cache[44] = [
                      _createElementVNode("i", { class: "bi bi-arrow-clockwise" }, null, -1)
                    ]))]),
                    _createElementVNode("button", {
                      class: "btn btn-custom",
                      type: "button",
                      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.exportToPng && _ctx.exportToPng(...args))),
                      title: "Eksport PNG"
                    }, [...(_cache[45] || (_cache[45] = [
                      _createElementVNode("i", { class: "bi bi-filetype-png" }, null, -1)
                    ]))]),
                    _createElementVNode("button", {
                      class: "btn btn-custom",
                      type: "button",
                      onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.exportToJpg && _ctx.exportToJpg(...args))),
                      title: "Eksport JPG"
                    }, [...(_cache[46] || (_cache[46] = [
                      _createElementVNode("i", { class: "bi bi-filetype-jpg" }, null, -1)
                    ]))]),
                    _createElementVNode("button", {
                      class: "btn btn-custom",
                      type: "button",
                      onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.exportCsv && _ctx.exportCsv(...args))),
                      title: "Eksport CSV"
                    }, [...(_cache[47] || (_cache[47] = [
                      _createElementVNode("i", { class: "bi bi-filetype-csv" }, null, -1)
                    ]))])
                  ]),
                  (_openBlock(), _createBlock(_component_LineChart, {
                    ref: "historyChart",
                    key: _ctx.chartRenderKey,
                    height: _ctx.fullscreenChartHeight,
                    "chart-id": _ctx.chartId,
                    "chart-data": _ctx.chartData,
                    options: _ctx.chartOptions,
                    plugins: _ctx.chartPlugins
                  }, null, 8, ["height", "chart-id", "chart-data", "options", "plugins"]))
                ], 2)
              ], 2))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}